import { Component, ViewChild, inject, OnInit } from '@angular/core';
import { DipendentiService } from '../../../shared/services/dipendenti.service';
import {
  DxDataGridComponent,
  DxTemplateDirective,
  DxLookupComponent,
  DxButtonComponent,
  DxDateBoxComponent,
  DxLoadPanelComponent,
} from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import * as FileSaver from 'file-saver';
import { MovimentoArticoliService } from 'src/app/shared/services/movimento-articoli.service';
import {
  MovimentoArticolo,
  MovimentoArticoloModel,
} from 'src/app/models/movimento-articolo';
import { Dipendente } from 'src/app/models/dipendente';
import { Articoli } from 'src/app/models/articoli';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import saveAs from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { HttpErrorResponse } from '@angular/common/http';
import {
  DxiColumnComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoSelectionComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { Mansioni } from 'src/app/models/mansioni';
import { Reparti } from 'src/app/models/reparti';
import { MansioniService } from 'src/app/shared/services/mansioni.service';
import { RepartiService } from 'src/app/shared/services/reparti.service';
import notify from 'devextreme/ui/notify';
import { PopupNewAllegatoMovimentiComponent } from 'src/app/shared/components/popups/popup-new-allegato-movimenti/popup-new-allegato-movimenti.component';
import { DetailAllegatiMovComponent } from 'src/app/shared/components/grid/detail-allegati-mov/detail-allegati-mov.component';
import { BtnNuovaConsegnaComponent } from 'src/app/shared/components/dipendenti/btn-nuova-consegna/btn-nuova-consegna.component';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-articoli-dipendente',
  templateUrl: './articoli-dipendente.component.html',
  styleUrls: ['./articoli-dipendente.component.scss'],
  imports: [
    DxDataGridComponent,
    DxTemplateDirective,
    DxLookupComponent,
    DxButtonComponent,
    DxDateBoxComponent,
    DxoExportComponent,
    DxoEditingComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxiColumnComponent,
    DxoLookupComponent,
    DxoTextsComponent,
    PopupNewAllegatoMovimentiComponent,
    DxLoadPanelComponent,
    DetailAllegatiMovComponent,
    DxoSelectionComponent,
    BtnNuovaConsegnaComponent,
  ],
  standalone: true,
})
export class ArticoliDipendenteComponent implements OnInit {
  private movS = inject(MovimentoArticoliService);
  private dipS = inject(DipendentiService);
  private articoliS = inject(ArticoliService);
  private nS = inject(NavigatorService);
  private mansioniS = inject(MansioniService);
  private repartiS = inject(RepartiService);

  @ViewChild('gridMovDipendente', { static: false })
    gridMovDipendente!: DxDataGridComponent;
  dataSource: any;
  listMovArticoli: MovimentoArticolo[];
  collapsed = false;
  listDip: Dipendente[] = [];
  listMansioni: Mansioni[] = [];
  listReparti: Reparti[] = [];
  selectedDip: Dipendente = null;
  listArticoli: Articoli[] = [];
  listFiltered: MovimentoArticolo[];
  gridVisible = false;
  movRif: MovimentoArticolo = null;

  dipSelezionato: any;

  aData: Date;
  daData: Date;
  loadPanelVisible = false;

  ngOnInit(): void {
    //Valorizzo le date (ultimo mese)
    const data = new Date();
    const realDay = data.getDate();
    const realMonth = data.getMonth();
    const realYear = data.getFullYear();
    this.daData = new Date(Date.UTC(realYear, realMonth, realDay - 30));
    this.aData = new Date(Date.UTC(realYear, realMonth, realDay));

    this.loadLookups();
  }

  loadLookups() {
    this.dipS.listTemp().subscribe({
      next: (dati) => {
        this.listDip = dati.sort(function (a, b) {
          return a.nominativo < b.nominativo ? -1 : 1;
        });
      }
    });

    this.articoliS.listTemp().subscribe({
      next: (articoli) => {
        this.listArticoli = articoli;
      }
    });

    this.mansioniS.list().subscribe({
      next: (dati) => {
        this.listMansioni = dati;
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento mansioni', 'warning');
        }
      },
    });

    this.repartiS.listTemp().subscribe({
      next: (dati) => {
        this.listReparti = dati;
      }
    });
  }

  scaricaFile(mov: MovimentoArticolo) {
    this.loadPanelVisible = true;
    this.movS.scarica(mov.id).subscribe({
      next: (res) => {
        this.loadPanelVisible = false;
        FileSaver.saveAs(res, mov.allegato);
      },
      error: (error) => {
        this.loadPanelVisible = false;
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore download file', 'warning');
        }
      },
    });
  }

  dipendenteSelected(data: any) {
    this.selectedDip = this.listDip.find((d) => d.id == data.value);
    console.log('selected: ' + JSON.stringify(this.selectedDip));
    this.dipSelezionato = data.value;
    this.dataSource = null;
  }

  onSearchClick() {
    this.loadDataSource();
  }

  onRowUpdating(e) {
    e.newData = Object.assign(e.oldData, e.newData);
  }

  loadDataSource() {
    if (this.daData != null && this.aData != null) {
      this.dataSource = new CustomStore({
        key: 'id',
        load: () => {
          return firstValueFrom(
            this.movS.filtered(
              null,
              this.dipSelezionato,
              null,
              this.daData,
              this.aData,
              true,
            ),
          )
            .then((response) => {
              return {
                data: response,
              };
            })
            .catch((error: HttpErrorResponse) => {
              if (error.error.title) {
                throw error.error.title;
              } else {
                throw 'Data loading error';
              }
            });
        },
        insert: (values) => {
          const model: MovimentoArticoloModel = {
            idDipendente: values.idDipendente,
            data: values.data,
            dettagli: values.dettagli,
            firmato: values.firmato,
            allegato: values.allegato,
            allegatoByte: values.allegatoByte,
            progr: values.progr,
            listDettaglio: [],
            nominativoDipendente: '',
            inviaMail: false,
          };
          return firstValueFrom(this.movS.insert(model))
            .then(() => {
              return values;
            })
            .catch(() => {
              throw 'Insertion failed';
            });
        },
        remove: (key) => {
          return (
            firstValueFrom(this.movS.remove(key))
              //.catch(() => { throw 'Deletion failed' });
              .then(() => console.log('delete eseguito'))
              .catch((error: HttpErrorResponse) => {
                //throw 'Deletion failed'
                console.log(error.error.title);
                throw error.error.title;
              })
          );
        },
        update: (key, values) => {
          return firstValueFrom(this.movS.update(key, values)).catch(() => {
            throw 'Update failed';
          });
        },
      });
    }
  }
  controlloDaData() {
    if (this.daData != null) {
      if (this.daData > this.aData) {
        this.aData = this.daData;
      }
      this.dataSource = null;
    }
  }
  controlloAData() {
    if (this.aData != null) {
      if (this.aData < this.daData) {
        this.daData = this.aData;
      }
      this.dataSource = null;
    }
  }

  onInitNewRow() {
    this.nS.goToNewMovimento();
    return false;
  }

  onRowRemoved() {
    this.movS.list().subscribe({
      next: (dati) => {
        this.listMovArticoli = dati;
        //this.loadDataSource(this.selectedDip.id);
        this.loadDataSource();
      },
      error: (error) => {
        this.loadPanelVisible = false;
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento movimenti dopo rimozione riga', 'warning');
        }
      },
    });
  }

  newAllegatoClick(movimento: MovimentoArticolo) {
    this.movRif = movimento;
  }

  //esportazione in excel
  onExporting(e: any) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(
      'ArticoliAssegnati_' + this.selectedDip.nominativo,
    );
    exportDataGrid({
      component: e.component,
      worksheet: worksheet,
      autoFilterEnabled: true,
    }).then(function () {
      // https://github.com/exceljs/exceljs#writing-xlsx
      workbook.xlsx.writeBuffer().then(function (buffer: any) {
        saveAs(
          new Blob([buffer], { type: 'application/octet-stream' }),
          worksheet.name + '.xlsx',
        );
      });
    });
    e.cancel = true;
  }

  exportDataPDF() {
    const righeSelezionate =
      this.gridMovDipendente.instance.getSelectedRowKeys();
    if (righeSelezionate.length == 0) {
      if (this.daData != null && this.aData != null) {
        this.loadPanelVisible = true;
        this.movS
          .stampaListaByDipDate(this.selectedDip.id, this.daData, this.aData)
          .subscribe({
            next: (scarica) => {
              this.loadPanelVisible = false;
              FileSaver.saveAs(
                scarica,
                `Elenco_assegnati_${this.selectedDip.codice}_temp.pdf`,
              );
            },
            error: (error) => {
              this.loadPanelVisible = false;
              if (error?.status == 500 && error?.error?.title) {
                notify(error?.error?.title, 'warning');
              } else {
                notify('Errore download file', 'warning');
              }
            },
          });
      } else {
        notify('Selezionare filtro date', 'warning');
      }
    } else {
      this.loadPanelVisible = true;
      const selection = new Object();
      selection['idsList'] = righeSelezionate;
      this.movS.stampaListaByMovs(this.selectedDip.id, selection).subscribe({
        next: (scarica) => {
          this.loadPanelVisible = false;
          FileSaver.saveAs(
            scarica,
            `Elenco_assegnati_${this.selectedDip.codice}_temp.pdf`,
          );
        },
        error: (error) => {
          this.loadPanelVisible = false;
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore download file', 'warning');
          }
        },
      });
    }
  }

  getArticoloDisplayExpr(item: Articoli) {
    if (!item) {
      return '';
    }

    return (
      item.codice +
      ' - ' +
      item.descrizione +
      (item.taglia ? ' - ' + item.taglia : '')
    );
  }

  getDipendenteDisplayExpr(item: Dipendente) {
    if (!item) {
      return '';
    }

    return item.codice + ' - ' + item.nominativo;
  }

  exportDocConsegnaPDF() {
    const righeSelezionate =
      this.gridMovDipendente.instance.getSelectedRowKeys();
    this.loadPanelVisible = true;
    const selection = new Object();
    selection['idsList'] = righeSelezionate;
    this.movS
      .esportaDocumenti(
        this.selectedDip?.id ?? 0,
        selection,
        this.daData,
        this.aData,
      )
      .subscribe({
        next: (scarica) => {
          this.loadPanelVisible = false;
          FileSaver.saveAs(
            scarica,
            `Estrazione_documenti_${this.selectedDip?.codice ?? ''}_temp.pdf`,
          );
        },
        error: (error) => {
          this.loadPanelVisible = false;
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore download documenti consegna', 'warning');
          }
        },
      });
  }

  exportDocConsegnaZip() {
    const righeSelezionate =
      this.gridMovDipendente.instance.getSelectedRowKeys();
    this.loadPanelVisible = true;
    const selection = new Object();
    selection['idsList'] = righeSelezionate;
    this.movS
      .esportaArchivio(
        this.selectedDip?.id ?? 0,
        selection,
        this.daData,
        this.aData,
      )
      .subscribe({
        next: (scarica) => {
          this.loadPanelVisible = false;
          FileSaver.saveAs(
            scarica,
            `Archivio_documenti_${this.selectedDip?.codice ?? ''}_temp.zip`,
          );
        },
        error: (error) => {
          this.loadPanelVisible = false;
          if (error?.status == 500 && error?.error?.title) {
            notify(error?.error?.title, 'warning');
          } else {
            notify('Errore download archivio', 'warning');
          }
        },
      });
  }

  onPopupNewAllegatoMovimentiEvent(e: any) {
    this.movRif = null;
    if (e) {
      this.loadDataSource();
    }
  }
}
